import { lazy } from 'react';

const BankAccountsPage = lazy(() => import('../../features/profile/pages/bank-accounts.page'));

const GatewayListPage = lazy(() => import('../../features/gateways/pages/gateway-list.page'));

const GatewaySettingsPage = lazy(
    () => import('../../features/gateways/pages/gateway-settings.page'),
);
const WithdrawListPage = lazy(() => import('../../features/withdrawals/pages/withdraw-list.page'));
const WithdrawShowPage = lazy(() => import('../../features/withdrawals/pages/withdraw-show.page'));
const InvoiceCreatePage = lazy(
    () => import('../../features/invoices/pages/invoice-create.page'),
);
const InvoiceListPage = lazy(
    () => import('../../features/invoices/pages/invoice-list.page'),
);

const TicketItem = lazy(
    () => import('features/tickets/components/ticket-item/ticket-item'),
);
const MarketingPage = lazy(() => import('features/marketing/pages/marketing.page'));
const MarketingWithdrawShowPage = lazy(
    () => import('features/marketing/pages/marketing-withdraw-show.page'),
);
const ShowNews = lazy(() => import('features/news/pages/show-news'));
const Report = lazy(() => import('../../features/reports/pages/reports.page'));
const Partners = lazy(() => import('../../features/partners/pages/partners.page'));
const Receipt = lazy(() => import('features/receipt/receipt'));
const TransactionShowPage = lazy(
    () => import('../../features/transactions/pages/transaction-show.page'),
);
const TransactionsListPage = lazy(
    () => import('../../features/transactions/pages/transactions-list.page'),
);
const TransactionAnalyticsPage = lazy(
    () => import('../../features/transaction-analytics/pages/transaction-analytics.page'),
);
const CustomerBehaviorAnalyticsPage = lazy(
    () => import('../../features/customer-behavior-analytics/pages/customer-behavior-analytics.page'),
);
const RangeReportPage = lazy(
    () => import('../../features/range-report/pages/range-report.page'),
);

import ProfileSettingsPage from '../../features/profile/pages/profile-settings.page';
import NewsListDataTable from 'features/news/pages/news-list.page';
import GatewayDashboardPage from '../../features/gateways/pages/gateway-dashboard.page';

// fallbacks
import PartnerFallback from 'components/fallbacks/partner.fallback';
import TicketFallback from 'components/fallbacks/ticket.fallback';
import MarketingFallback from 'components/fallbacks/marketing.fallback';
import ProfileFallback from 'components/fallbacks/profile.fallback';
import DataTableFallback from 'components/fallbacks/data-table.fallback';
import WithdrawFallback from 'components/fallbacks/withdraw.fallback';
import WithdrawDetailsFallback from 'components/fallbacks/withdraw-details.fallback';
import TransactionDetailsFallback from 'components/fallbacks/transaction-details.fallback';
import TransactionAnalyticsFallback from 'components/fallbacks/transaction-analytics.fallback';
import GatewayDashboardFallback from 'components/fallbacks/gateway-dashboard.fallback';
import GatewaySettingsFallback from 'components/fallbacks/gateway-settings.fallback';

export {
    GatewayListPage,
    GatewayDashboardPage,
    GatewaySettingsPage,
    TransactionsListPage,
    TransactionShowPage,
    TransactionAnalyticsPage,
    CustomerBehaviorAnalyticsPage,
    RangeReportPage,
    WithdrawListPage,
    WithdrawShowPage,
    InvoiceCreatePage,
    InvoiceListPage,
    ProfileSettingsPage,
    BankAccountsPage,
    TicketItem as TicketPage,
    MarketingPage,
    MarketingWithdrawShowPage,
    NewsListDataTable,
    ShowNews,
    Partners,
    Report,
    Receipt,
    // fallbacks
    PartnerFallback,
    TicketFallback,
    MarketingFallback,
    ProfileFallback,
    DataTableFallback,
    WithdrawFallback,
    WithdrawDetailsFallback,
    TransactionDetailsFallback,
    TransactionAnalyticsFallback,
    GatewayDashboardFallback,
    GatewaySettingsFallback,
};
